import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from '../login/forgot-password/forgot-password.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { PrimengModule } from '../common/modules/primeng/primeng.module';



@NgModule({
  entryComponents: [ForgotPasswordComponent],
  imports: [
    AuthRoutingModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    PrimengModule
  ],
  declarations: [ForgotPasswordComponent],
  providers: [ConfirmationService]
})
export class AuthModule { }
